import { render, staticRenderFns } from "./CreateRawBag.vue?vue&type=template&id=492d278a&scoped=true"
import script from "./CreateRawBag.vue?vue&type=script&lang=js"
export * from "./CreateRawBag.vue?vue&type=script&lang=js"
import style0 from "./CreateRawBag.vue?vue&type=style&index=0&id=492d278a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "492d278a",
  null
  
)

export default component.exports